class Timeline {
  constructor(layers = [], keyframes = []) {
    const props = {
      layers,
      keyframes,
      currentKeyframe: 0,
      currentTime: 0,
      typeof: 'Timeline',
    };

    Object.assign(this, props);
  }

  play() {
    // console.log('ct: ', this.currentTime);
    // this.currentTime += 1000 / 60;
    //
    let keyframe = this.keyframes[this.currentKeyframe];
    //
    // console.log('ts_i: ', keyframe.timestamp);
    //
    // while (keyframe && this.currentTime >= keyframe.timestamp) {
    //   console.log('ts: ', keyframe.timestamp);
    //   this.currentKeyframe += 1;
    //
    //   keyframe = this.keyframes[this.currentKeyframe];
    // }
    //
    // console.log('ts_f: ', keyframe.timestamp);
    //
    // this.currentKeyframe -= 1;
    //
    // keyframe = this.keyframes[this.currentKeyframe];

    if (keyframe && this.currentTime >= keyframe.timestamp) {
      keyframe.layers.forEach((layer) => {
        const target = this.layers[layer.index];

        switch (target.typeof) {
          case 'Sound':
            switch (layer.method) {
              case 'stop':
                target.stop();

                break;
              default:
                target.play(layer.params.sprite);
            }

            break;
          case 'Intro':
            switch (layer.method) {
              case 'stop':
                target.stop();

                break;
              case 'slideTo':
                target.slideTo(layer.params.index)

                break;
              default:
                target.play(layer.params.sprite);
            }

            break;
          case 'Graphic':
            switch (layer.method) {
              case 'slideToYear':
                target.slideToYear(layer.params);

                break;
              case 'highlightTeams':
                target.highlightTeams(layer.params);

                break;
              case 'highlightMatch':
                target.highlightMatch(layer.params);

                break;
              default:
                target.play();
            }

            break;
          default:
            switch (layer.method) {
              case 'stop':
                target.stop();

                break;
              default:
                target.play();
            }
        }
      });

      this.currentKeyframe += 1;
    }

    // console.log(this.currentTime);
    this.currentTime += deltaTime;

    this.loop = requestAnimationFrame(() => {
      return this.play();
    });
  }

  pause() {
    cancelAnimationFrame(this.loop);
  }

  prev() {
    let keyframe = this.keyframes[this.currentKeyframe - 1];

    if (keyframe) {
      this.currentTime = keyframe.timestamp;

      this.currentKeyframe -= 1;
    }

    return keyframe.timestamp;
  }

  next() {
    let keyframe = this.keyframes[this.currentKeyframe];

    if (keyframe) {
      this.currentTime = keyframe.timestamp;
    }

    return keyframe.timestamp;
  }

  nextSlide() {
    let keyframe = this.keyframes[this.currentKeyframe];

    if (keyframe) {
      if (keyframe.layers[0].method !== 'slideToYear') {
        this.currentKeyframe += 1;

        this.nextSlide();
      } else {
        this.currentTime = keyframe.timestamp;

        sound.seek(this.currentTime / 1000);
      }
    }

    return keyframe.timestamp;
  }

  nextChapter() {
    let keyframe = this.keyframes[this.currentKeyframe + 36];

    if (keyframe) {
      this.currentTime = keyframe.timestamp;
    }

    return keyframe.timestamp;
  }
}
